import React, { FC } from 'react'

export interface FilterSvgProps {
  className?: string
}

export const FilterSvg: FC<FilterSvgProps> = ({ className }) => (
  <svg
    className={className}
    width="14"
    height="18"
    viewBox="0 0 14 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5475 0C13.273 0 14.1887 2.03855 13.0426 3.32843L8.67652 8.24216C8.51389 8.4252 8.42406 8.66153 8.42406 8.90638V15.4873C8.42406 15.8662 8.2099 16.2126 7.87093 16.3819L6.07845 17.2773C5.41357 17.6094 4.63158 17.1259 4.63158 16.3827V8.8694C4.63158 8.64703 4.55746 8.43099 4.42093 8.25546L0.510583 3.22788C-0.511198 1.91417 0.424988 0 2.08929 0H11.5475Z"
      fill="#46AAE9"
    />
  </svg>
)
